// Iteration 1.14 — arena lobby render. Text-only "Start game" button on a
// black field. The button rect is computed from canvas size each frame so
// the hit-test stays in sync with the rendered geometry.

const BUTTON_W = 220
const BUTTON_H = 56
const TITLE = 'EMERGENCE VECTOR'
const SUBTITLE = 'arena_lobby'
const BUTTON_LABEL = 'Start game'

export function renderArenaLobby(opts) {
  const { canvas } = opts
  const ctx = canvas.getContext('2d')
  const w = canvas.width
  const h = canvas.height

  ctx.fillStyle = '#000'
  ctx.fillRect(0, 0, w, h)

  ctx.save()
  ctx.fillStyle = '#bbb'
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.font = 'bold 28px system-ui, sans-serif'
  ctx.fillText(TITLE, w / 2, h / 2 - 80)
  ctx.fillStyle = '#666'
  ctx.font = '14px system-ui, sans-serif'
  ctx.fillText(SUBTITLE, w / 2, h / 2 - 50)

  const r = buttonRect(canvas)
  ctx.strokeStyle = '#7f7'
  ctx.lineWidth = 2
  ctx.strokeRect(r.x, r.y, r.w, r.h)
  ctx.fillStyle = '#7f7'
  ctx.font = 'bold 18px system-ui, sans-serif'
  ctx.fillText(BUTTON_LABEL, r.x + r.w / 2, r.y + r.h / 2)
  ctx.restore()
}

// buttonRect returns the current Start-game button rect in canvas
// coordinates. Exported so click handlers can hit-test against the
// same geometry the renderer drew.
export function buttonRect(canvas) {
  const w = canvas.width
  const h = canvas.height
  return {
    x: (w - BUTTON_W) / 2,
    y: (h - BUTTON_H) / 2 + 10,
    w: BUTTON_W,
    h: BUTTON_H,
  }
}

// pointInButton tests a canvas-coordinate point against the current
// button rect. Used by the click handler in main.js.
export function pointInButton(canvas, x, y) {
  const r = buttonRect(canvas)
  return x >= r.x && x <= r.x + r.w && y >= r.y && y <= r.y + r.h
}
